module.exports = __webpack_public_path__ + "static/media/instagram.075db3a4.svg";